import { createNextTableContext } from '@core/table';

export const ReturnTypesTableContext = createNextTableContext();
